<i18n lang="yaml">
en:
  delete_member: 'Are you sure you want to delete this member?'
ru:
  delete_member: 'Вы уверены, что хотите удалить этого участника?'
</i18n>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const router = useRouter()
const props = defineProps({
  id: String,
  email: String,
  role: {
    type: String,
    required: true
  },
  tags: Array<String>,
  is_invited: Boolean,
  unix_username: String
})

const emit = defineEmits(['delete'])

function onDelete(event: Event) {
  event.stopPropagation()
  if (confirm(t('delete_member'))) {
    emit('delete', props.id)
  }
}

async function edit() {
  await router.push({ name: 'organizations:members:edit', params: { member_id: props.id } })
}

function shouldDisplayDeleteButton() {
  return props.role !== 'owner'
}
</script>

<template>
  <div class="card h-100" @click="edit">
    <div class="card-body">
      <img v-if="is_invited" src="@/assets/person-add.svg" class="mb-2" />
      <img v-else src="@/assets/person.svg" class="mb-2" />
      <button
        v-if="shouldDisplayDeleteButton()"
        @click="onDelete"
        class="btn btn-danger btn-close float-end"
      />
      <h5 class="card-title mt-1">{{ email }}</h5>
      <h6 class="card-subtitle text-muted mt-1">{{ t(`role.${props.role}`) }}</h6>
      <h6 class="card-subtitle text-muted mt-2">
        <kbd>{{ props.unix_username }}</kbd>
      </h6>

      <div class="mt-2">
        <span key="tag" v-for="tag in tags" class="badge bg-primary me-2">{{ tag }}</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.card {
  /* border-radius: 4px; */
  background: #fff;
  transition:
    0.3s transform cubic-bezier(0.155, 1.105, 0.295, 1.12),
    0.3s box-shadow,
    0.3s -webkit-transform cubic-bezier(0.155, 1.105, 0.295, 1.12);
  padding: 14px 14px 14px 14px;
  cursor: pointer;
}

.card:hover {
  transform: scale(1.01);
  box-shadow:
    0 10px 20px rgba(0, 0, 0, 0.12),
    0 4px 8px rgba(0, 0, 0, 0.06);
}

.card-title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
